module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selling-small-494138fd180887e69b78352a39cfcb9b.svg";